import { Fragment } from "react";
import styled from "styled-components/macro";
import { Typography, Checkbox, Grid, Box } from "@mui/material";
import { ToggleOnOutlined, ToggleOffOutlined } from "@mui/icons-material";

import { Label } from "../../../components";
import Input from "./audience fields/Input";
import Range from "./audience fields/Range";
import DropDown from "./audience fields/Dropdown";
import DatePicker from "./audience fields/DatePicker";
import AudienceName from "./audience fields/AudienceName";
import { colors } from "../../css components/Style";

const Heading = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  line-height: 27px;
  align-self: center;
`;

export default function FormOne({
  state,
  dispatch,
  fields,
  editState,
  formikProps,
  countSelectedIOH,
}) {
  let counts = countSelectedIOH();
  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="caption1" color={"#ED1C24"}>
          NOTE :
          <br />
          * Indosat Attributes (At least 2 data mandatory)
          <br /> * You can select max 5 attributes.
        </Typography>
      </Grid>

      <AudienceName
        state={state}
        dispatch={dispatch}
        editState={editState}
        formikProps={formikProps}
      />

      {fields?.ioh?.length > 0 && (
        <Fragment>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: "15px", color: colors.sideBarColor }}>
              Indosat Attributes
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ paddingTop: "16px!important" }}>
            <Box
              sx={{
                height: "2px",
                backgroundColor: colors.sideBarColor,
                width: "calc(100% + 32px)",
                ml: "-16px",
                mr: "-16px",
              }}
            />
          </Grid>

          {fields?.ioh?.map((field) => (
            <Attribute
              state={state}
              dispatch={dispatch}
              field={field}
              editState={editState}
              formikProps={formikProps}
            />
          ))}
        </Fragment>
      )}

      {fields?.other?.length > 0 && (
        <Fragment>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: "15px", color: colors.sideBarColor }}>
              Other Contributor Attributes
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ paddingTop: "16px!important" }}>
            <Box
              sx={{
                height: "2px",
                backgroundColor: colors.sideBarColor,
                width: "calc(100% + 32px)",
                ml: "-16px",
                mr: "-16px",
              }}
            />
          </Grid>

          {fields?.other?.map((field) => (
            <Attribute
              counts={counts}
              state={state}
              dispatch={dispatch}
              field={field}
              editState={editState}
              formikProps={formikProps}
            />
          ))}
        </Fragment>
      )}
    </Fragment>
  );
}

function Attribute({ counts, state, dispatch, field, editState, formikProps }) {
  return (
    <Fragment>
      {field.control_id === 3 && (
        <Input
          counts={counts}
          state={state}
          dispatch={dispatch}
          editState={editState}
          field={field}
          formikProps={formikProps}
        />
      )}

      {field.control_id === 1 && (
        <Range
          counts={counts}
          state={state}
          dispatch={dispatch}
          editState={editState}
          field={field}
          formikProps={formikProps}
        />
      )}

      <DropDown
        counts={counts}
        state={state}
        dispatch={dispatch}
        editState={editState}
        field={field}
        formikProps={formikProps}
      />

      {field.control_id === 4 && (
        <DatePicker
          counts={counts}
          state={state}
          dispatch={dispatch}
          editState={editState}
          field={field}
          formikProps={formikProps}
        />
      )}
    </Fragment>
  );
}

export function Mandatory({ state, field, dispatch, editState, formikProps }) {
  function handleCheckChange(value, name, key) {
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  let val = state?.[field.name]?.mandatory;

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Label title={field.label} />

      {/* {field.is_ioh_contributor && (
        <Fragment>
          <Heading
            style={{
              color: state?.[field.name]?.mandatory ? "red" : "gray",
            }}
          >
            Mandatory
          </Heading>

          <Checkbox
            style={{ padding: "3px 9px" }}
            disabled={
              field.control_id === 1
                ? !state?.[field.name]?.value?.min ||
                  !state?.[field.name]?.value?.max ||
                  !editState
                : !editState ||
                  !state?.[field.name]?.value ||
                  state?.[field.name]?.value?.length === 0
            }
            name={`${field.name}.mandatory`}
            onChange={(e) => {
              handleCheckChange(e.target.checked, field.name, "mandatory");
            }}
            checked={val === true ? true : false}
            icon={<ToggleOffOutlined fontSize="large" />}
            checkedIcon={
              <ToggleOnOutlined fontSize="large" style={{ color: "red" }} />
            }
          />
        </Fragment>
      )} */}
    </div>
  );
}
